(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lvdg-campaign-clock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('samael-campaign-clock')) {
    class SamaelCampaignClock extends HTMLElement {
      constructor() {
        super();
        this.refresh = this.refresh.bind(this);
      }
      connectedCallback() {
        this.refresh();
        window.addEventListener('pageshow', this.refresh);
        document.addEventListener('visibilitychange', this.refresh);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        window.removeEventListener('pageshow', this.refresh);
        document.removeEventListener('visibilitychange', this.refresh);
      }
      refresh() {
        clearTimeout(this.timer);
        const bounds = [this.dataset.openAt, this.dataset.dispatchAt, this.dataset.afterAt].map(Number);
        if (!bounds.every(Number.isFinite) || !(bounds[0] < bounds[1] && bounds[1] < bounds[2])) return;
        const now = Date.now();
        const phase = now < bounds[0] ? 'opening' : now < bounds[1] ? 'preparing' : now < bounds[2] ? 'dispatch' : 'followup';
        this.dataset.phase = phase;
        this.querySelectorAll('[data-campaign-phases]').forEach(node => {
          node.hidden = !node.dataset.campaignPhases.split(' ').includes(phase);
        });
        this.querySelectorAll('[data-campaign-step]').forEach(node => {
          const current = node.dataset.campaignStep === phase;
          node.classList.toggle('is-current', current);
          if (current) node.setAttribute('aria-current', 'step');
          else node.removeAttribute('aria-current');
        });
        const next = bounds.find(value => value > now);
        if (next && this.isConnected) {
          this.timer = setTimeout(this.refresh, Math.max(25, Math.min(60000, next - now + 25)));
        }
      }
    }
    customElements.define('samael-campaign-clock', SamaelCampaignClock);
  }
  } catch(e) { console.error(e); }
})();

})();
